const babyRouterMap = [
  {
    name: "儿科首页",
    path: "/baby/home",
    component: () => import("@/pages/baby/home"),
    meta: {
      systemCode: 'erke',
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "孕期管理",
    path: "/baby/managelist",
    component: () => import("@/pages/baby/managelist")
  },
  {
    name: "宝宝记录",
    path: "/baby/pregnancyrecords",
    component: () => import("@/pages/baby/pregnancyrecords")
  },
  {
    name: "宝宝辅食",
    path: "/baby/food",
    component: () => import("@/pages/baby/food"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "食谱详情",
    path: "/baby/food/detail",
    component: () => import("@/pages/baby/fooddetail")
  },
  {
    name: "专家课堂",
    path: "/baby/classroom",
    component: () => import("@/pages/baby/classroom"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "专家课堂详情",
    path: "/baby/classroom/detail",
    component: () => import("@/pages/baby/classroomdetail"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "生长发育去记录",
    path: "/baby/growthhome",
    component: () => import("@/pages/baby/growthhome"),
    meta: {
      systemCode: 'growthhome'
    }
  },
  {
    name: "新增宝宝记录",
    path: "/baby/submit",
    component: () => import("@/pages/baby/submit")
  },
  {
    name: "历史记录",
    path: "/baby/recordlist",
    component: () => import("@/pages/baby/recordlist"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "宝宝生长发育报告",
    path: "/baby/reporthome",
    component: () => import("@/pages/baby/reporthome")
  },
  {
    name: "疫苗接种表",
    path: "/baby/vaccine/list",
    component: () => import("@/pages/baby/vaccinelist"),
    meta: {
      systemCode: 'vaccine',
      isUseCache: true,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "疫苗详情",
    path: "/baby/vaccine/detail",
    component: () => import("@/pages/baby/vaccinedetail")
  },
  {
    name: "体检时间表",
    path: "/baby/checkup/list",
    component: () => import("@/pages/baby/checkuplist"),
    meta: {
      systemCode: 'checkup',
      isUseCache: true,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "体检详情",
    path: "/baby/checkup/detail",
    component: () => import("@/pages/baby/checkupdetail")
  },
  {
    name: "设置宝宝信息",
    path: "/baby/setbabyinfo",
    component: () => import("@/pages/baby/setbabyinfo")
  },
  {
    name: "设置宝宝信息去完善",
    path: "/baby/setinfostep",
    component: () => import("@/pages/baby/setinfostep")
  },
  {
    name: "设置宝宝信息",
    path: "/baby/setInfo",
    component: () => import("@/pages/baby/setInfo"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "设置宝宝身高体重",
    path: "/baby/setdevelopment",
    component: () => import("@/pages/baby/setdevelopment"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "设置宝宝分娩方式",
    path: "/baby/setborntype",
    component: () => import("@/pages/baby/setborntype"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "修改宝宝姓名",
    path: "/baby/editname",
    component: () => import("@/pages/baby/editname")
  },
  {
    name: "成长测评",
    path: "/baby/review",
    component: () => import("@/pages/baby/review")
  },
  {
    name: "专科门诊",
    path: "/baby/specialist",
    component: () => import("@/pages/baby/specialist"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "专科门诊详情",
    path: "/baby/specialist/detail",
    component: () => import("@/pages/baby/specialistdetail"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "我的收藏",
    path: "/baby/mycollect",
    component: () => import("@/pages/baby/mycollect"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "育儿知识",
    path: "/baby/pediatric",
    component: () => import("@/pages/baby/pediatric"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "育儿知识详情",
    path: "/baby/article/detail",
    component: () => import("@/pages/baby/articledetail")
  },
  {
    name: "宝宝长牙记录表",
    path: "/baby/tooth",
    component: () => import("@/pages/baby/tooth"),
    meta: {
      systemCode: 'tooth'
    }
  }, {
    name: "母子健康手册",
    path: "/baby/healthBookV3",
    component: () => import("@/pages/baby/healthBookV3"),
    meta: {
      systemCode: 'tooth'
    }
  },
  {
    name: "多动症测量表",
    path: "/baby/adhdtable",
    component: () => import("@/pages/baby/adhdtable")
  },
  {
    name: "测试结果",
    path: "/baby/testresult",
    component: () => import("@/pages/baby/testresult")
  }
];
export default babyRouterMap;
